module.exports = __webpack_public_path__ + "img/marcador.85422361.svg";